var React = require('react');

function Gitlab (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#FC6D26","d":"M126.615 72.31l-7.034-21.647L105.64 7.76c-.716-2.206-3.84-2.206-4.556 0l-13.94 42.903H40.856L26.916 7.76c-.717-2.206-3.84-2.206-4.557 0L8.42 50.664 1.385 72.31a4.792 4.792 0 0 0 1.74 5.358L64 121.894l60.874-44.227a4.793 4.793 0 0 0 1.74-5.357","key":0}),React.createElement("path",{"fill":"#E24329","d":"M64 121.894l23.144-71.23H40.856L64 121.893z","key":1}),React.createElement("path",{"fill":"#FC6D26","d":"M64 121.894l-23.144-71.23H8.42L64 121.893z","key":2}),React.createElement("path",{"fill":"#FCA326","d":"M8.42 50.663L1.384 72.31a4.79 4.79 0 0 0 1.74 5.357L64 121.894 8.42 50.664z","key":3}),React.createElement("path",{"fill":"#E24329","d":"M8.42 50.663h32.436L26.916 7.76c-.717-2.206-3.84-2.206-4.557 0L8.42 50.664z","key":4}),React.createElement("path",{"fill":"#FC6D26","d":"M64 121.894l23.144-71.23h32.437L64 121.893z","key":5}),React.createElement("path",{"fill":"#FCA326","d":"M119.58 50.663l7.035 21.647a4.79 4.79 0 0 1-1.74 5.357L64 121.894l55.58-71.23z","key":6}),React.createElement("path",{"fill":"#E24329","d":"M119.58 50.663H87.145l13.94-42.902c.717-2.206 3.84-2.206 4.557 0l13.94 42.903z","key":7})]);
}

Gitlab.displayName = "Gitlab";

Gitlab.defaultProps = {"viewBox":"0 0 128 128"};

module.exports = Gitlab;

Gitlab.default = Gitlab;



//////////////////
// WEBPACK FOOTER
// ./src/images/inline-svg/gitlab.svg
// module id = 875
// module chunks = 35783957827783